import { render, staticRenderFns } from "./BrowserNotification.vue?vue&type=template&id=316a2e29&scoped=true"
import script from "./BrowserNotification.vue?vue&type=script&lang=js"
export * from "./BrowserNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316a2e29",
  null
  
)

export default component.exports